export default __webpack_public_path__ + "lines_tablet@2x.53c0d194.png";